<template>
  <section class="flex flex-wrap px-8">
    <div class="flex flex-wrap items-center">
      <router-link
        v-for="section in sectionsList"
        :key="section.pk"
        :to="{ name: viewName, params: { slug: section.slug } }"
        class="flex items-center px-5 py-1 m-2 bg-gray-200 rounded transition duration-200 hover:bg-secondary-200"
        :class="{ active: section.slug === currentSection.slug }"
      >
        <div class="text-4xl font-bold">{{ section.order }}</div>
        <div class="text-lg pl-4">{{ section.title }}</div>
      </router-link>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    slug: {
      type: String,
      required: false,
      default: '',
    },

    viewName: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState('sections', ['sectionsList', 'currentSection']),
  },
}
</script>

<style scoped>
.active {
  @apply bg-secondary-500 text-white;
}

.active:hover {
  @apply bg-secondary-500 text-white;
}
</style>
